import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Email Sync Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-email-sync-outline',
    templateUrl: './icon-email-sync-outline.component.html',
    styleUrls: ['./icon-email-sync-outline.component.scss'],
    standalone: false
})
export class IconEmailSyncOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
